import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import BankTransactionPanel from './BankTransactionPanel';
import LedgerEntryPanel from './LedgerEntryPanel';
import MatchingArea from './MatchingArea';

const MobileReconciliationTabs = ({
  bankTransactions,
  ledgerEntries,
  selectedBankTransactions,
  selectedLedgerEntries,
  onBankTransactionSelect,
  onLedgerEntrySelect,
  onDragStart,
  onDrop,
  onMatch,
  onUnmatch,
  suggestedMatches,
  draggedItem,
  draggedSource
}) => {
  const [activeTab, setActiveTab] = useState('bank');

  const tabs = [
    { id: 'bank', label: 'Bank', icon: 'Building2', count: bankTransactions?.length },
    { id: 'ledger', label: 'Ledger', icon: 'BookOpen', count: ledgerEntries?.length },
    { id: 'match', label: 'Match', icon: 'ArrowLeftRight', count: selectedBankTransactions?.length + selectedLedgerEntries?.length }
  ];

  return (
    <div className="lg:hidden">
      <div className="bg-card rounded-lg shadow-sm border border-border mb-4">
        <div className="flex border-b border-border overflow-x-auto">
          {tabs?.map((tab) => (
            <button
              key={tab?.id}
              onClick={() => setActiveTab(tab?.id)}
              className={`
                flex-1 min-w-0 px-4 py-3 flex items-center justify-center gap-2 transition-smooth
                ${activeTab === tab?.id
                  ? 'bg-primary text-primary-foreground border-b-2 border-primary'
                  : 'text-muted-foreground hover:bg-muted'
                }
              `}
            >
              <Icon name={tab?.icon} size={18} />
              <span className="font-body font-medium text-sm whitespace-nowrap">{tab?.label}</span>
              {tab?.count > 0 && (
                <span className={`
                  px-2 py-0.5 rounded-full text-xs font-medium
                  ${activeTab === tab?.id
                    ? 'bg-primary-foreground/20 text-primary-foreground'
                    : 'bg-muted text-muted-foreground'
                  }
                `}>
                  {tab?.count}
                </span>
              )}
            </button>
          ))}
        </div>
      </div>
      <div className="min-h-[500px]">
        {activeTab === 'bank' && (
          <BankTransactionPanel
            transactions={bankTransactions}
            onTransactionSelect={onBankTransactionSelect}
            selectedTransactions={selectedBankTransactions}
            onDragStart={onDragStart}
          />
        )}

        {activeTab === 'ledger' && (
          <LedgerEntryPanel
            entries={ledgerEntries}
            onEntrySelect={onLedgerEntrySelect}
            selectedEntries={selectedLedgerEntries}
            onDragStart={onDragStart}
            suggestedMatches={suggestedMatches}
          />
        )}

        {activeTab === 'match' && (
          <MatchingArea
            selectedBankTransactions={selectedBankTransactions}
            selectedLedgerEntries={selectedLedgerEntries}
            bankTransactions={bankTransactions}
            ledgerEntries={ledgerEntries}
            onDrop={onDrop}
            onMatch={onMatch}
            onUnmatch={onUnmatch}
            draggedItem={draggedItem}
            draggedSource={draggedSource}
          />
        )}
      </div>
    </div>
  );
};

export default MobileReconciliationTabs;